import InboxRuleRequestStatus from './schema/InboxRuleRequestStatus';
import InboxRulesOptionState from './schema/InboxRulesOptionState';
import initializeInboxRulesEditState from '../actions/helpers/initializeInboxRulesEditState';
import { ObservableMap } from 'mobx';
import { createStore } from 'satcheljs';

export default createStore<InboxRulesOptionState>('inboxRulesOption', {
    inboxRulesListState: {
        inboxRules: new ObservableMap(),
        inboxRuleIds: [],
        getInboxRuleRequestStatus: InboxRuleRequestStatus.NotInitiated,
        getInboxRuleDiagnosticRequestStatus: InboxRuleRequestStatus.NotInitiated,
        hasLoggedGetInboxRulesInformation: false,
    },
    inboxRulesEditState: initializeInboxRulesEditState(),
    messageClassifications: [],
    findFoldersRequestStatus: InboxRuleRequestStatus.NotInitiated,
    contextMenuFolders: [],
    junkFolderDisplayName: '',
})();
